import { AuthContext } from 'context/AuthContext';
import { useContext } from 'react';

export const useAuth = () => {
    const { auth, ...rest } = useContext(AuthContext);

    const currentRole = auth?.user?.role;
    return { auth, currentRole, ...rest };
};
